<template>
  <div class="qualificationCenter">
    <!-- <div id="blurr"></div>
    <div id="accc"></div> -->
    <el-dialog
      customClass="customWidth"
      :visible.sync="dialogVisible"
      :show-close="false"
      :lock-scroll="false"
      :center="true"
      title=""
      class="popups"
    >
      <div slot="title" class="dialog-title">
        <!-- <img :src="this.imgPath" alt="" /> -->
        <img ref="watermarkImg" :src="imgPath || defaultImg" alt="" />
        <h2>{{ this.title }}</h2>
      </div>
      <img
        class="dialog-close"
        src="@/assets/img/case/icon_close@2x.png"
        @click="dialogVisible = false"
      />
    </el-dialog>

    <!-- <div class="none" id="popular">
      <div class="button">
        <div class="a" @click="toggle"></div>
        <img :src="this.imgPath" alt="" />
        <h1>{{ this.title }}</h1>
      </div>
    </div> -->

    <div class="center-right ortherTitle">
      <h1>荣誉</h1>
      <p>
        其他行业协会，是指非安防、智慧交通分类的协会，行业协会的任务和关注领域因行业而异，可以涵盖从医疗保健、科技、教育、金融到制造业等广泛领域。它们的存在有助于塑造行业未来，维护声誉，推动可持续发展，为成员提供支持和竞争优势，以满足市场需求和社会期望。
      </p>
      <div class="center-nav">
        <a style="pointer-events: none" href=""
          ><span class="color">荣誉<i class="bgc"></i></span
        ></a>

        <span></span>
      </div>

      <ul class="orther">
        <li v-for="(person, index) in watermarkedImageList" :key="index">
          <div class="img">
            <img
              @click="toggle(index)"
              :src="person.imgPath || defaultImg"
              alt=""
            />
          </div>
          <div class="text">
            {{ person.title }}
          </div>
        </li>
      </ul>
      <div
        v-if="!isLoading"
        class="loadingBox"
        v-loading="!isLoading"
        element-loading-text="正在加载中"
      ></div>
      <!-- 分页 -->
      <!-- <div
        v-show="total > 12 && watermarkedImageList.length > 0"
        class="pagination"
      > -->
      <div v-show="total > 12 && isLoading" class="pagination">
        <el-pagination
          background
          layout="prev, pager, next,jumper"
          :total="total"
          :current-change="pageNum"
          @current-change="handleCurrentChange"
          :page-size="12"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { addWatermarkToData } from "@/utils/watermarkAddition";
export default {
  name: "other",
  data() {
    return {
      arr: [],
      status: 1,
      type: 3,
      imgPath: "",
      title: "",
      dialogVisible: false,
      total: 0,
      pageNum: 1,
      pageSize: 12,
      originalImages: [], // 存储从接口获取的原始图片数据
      watermarkedImages: [], // 存储带水印的图片地址
      watermarkedImageList: [], //存储所有带水印的图片地址
      isLoading: false,
      defaultImg: require("../../assets/default.png")
    };
  },
  mounted() {
    this.select();
  },
  methods: {
    async select() {
      try {
        const res = await this.request.get(`/${this.status}/${this.type}`, {
          params: {
            pageSize: this.pageSize,
            pageNum: this.pageNum,
            category: "荣誉",
            sort: 1
          }
        });

        this.arr = res.data.data;
        this.total = res.data.total;
        this.originalImages = res.data.data;
        // 调用函数并传入数据数组
        await addWatermarkToData(res.data.data, this);
      } catch (error) {
        console.error("请求数据出错", error);
      }
    },
    handleCurrentChange(pageNum) {
      this.isLoading = false;
      (this.pageNum = pageNum), this.select();
      this.scrollToPosition();
      this.$nextTick(window.scrollBy(0, 50));
    },
    scrollToPosition(position) {
      window.scrollTo({
        top: 400
      });
    },
    toggle(index) {
      if (index >= 0) {
        // this.imgPath = this.arr[index].imgPath;
        this.imgPath = this.watermarkedImageList[index].imgPath;
        this.title = this.arr[index].title;
        // this.content = this.getSimpleText(this.arr[index].content)
      }
      // var sy = document.getElementById("accc").style.display;
      // if (sy === "inline") {
      //   document.getElementById("accc").style.display = "none";
      // } else {
      //   document.getElementById("accc").style.display = "inline";
      // }
      // console.log(document.getElementById("accc").style.display + "###");
      // var blur = document.getElementById("blurr");
      // blur.classList.toggle("active");
      // var popular = document.getElementById("popular");
      // popular.classList.toggle("active");
      // var acc = document.getElementById("accc");
      // acc.classList.toggle("active");
      this.dialogVisible = true;
      document.body.style.paddingRight = "0px";
    },
    getSimpleText(html) {
      const re1 = new RegExp("<.+?>", "g"); // 匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      const arrEntities = {
        lt: "<",
        gt: ">",
        nbsp: " ",
        amp: "&",
        quot: '"',
        ldquo: "“",
        mdash: "—",
        rdquo: "”"
      };
      return html
        .replace(re1, "")
        .replace(/&(lt|gt|nbsp|amp|quot|ldquo|mdash|rdquo);/gi, function(
          all,
          t
        ) {
          return arrEntities[t];
        });
    }
  }
};
</script>
<style scoped>
/* @media screen and (max-width: 1285px) and (min-width: 950px) {
  body .center-right {
    width: 100%;
  }
}
@media screen and (max-width: 950px) {
  body .center-right {
    width: 100%;
  }
} */
.popups {
  width: 100%;
}
.dialog-close {
  position: absolute;
  top: 0;
  right: -56px;
  width: 32px;
  height: 32px;
  cursor: pointer;
}
.dialog-title img {
  padding: 0vw;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

li {
  width: 102px;
  list-style: none;
  margin-right: 54px;
  cursor: pointer;
}
.center-right {
  float: left;
  /* width:1138px; */
  width: 1330px;
}
.center-right h1 {
  margin-bottom: 33px;
  font-size: 31px;
  color: #140047;
  line-height: 42px;
  letter-spacing: 1.92px;
}
.center-right .center-nav .color {
  display: block;
  width: 102px;
  color: #140047;
  font-size: 16px;
  line-height: 23px;
}
.center-right .center-nav .bgc {
  /* width: 70px; */
  width: 34px;
  background-color: #140047;
}
.center-right .center-nav .active2 a span i {
  background-color: #140047;
}
.center-right p {
  margin-bottom: 33px;
  font-size: 16px;
  font-weight: 400;
  color: #01021b;
  line-height: 29px;
  letter-spacing: 0.96px;
  opacity: 0.72;
}
.center-right .center-nav {
  margin-bottom: 32px;
  display: flex;
  position: relative;
}
.center-right .center-nav a {
  width: 102px;
  height: 48px;
  margin-right: 54px;
  font-size: 20px;
  font-weight: 550;
  color: rgba(0, 0, 0, 0.3);
  line-height: 28px;
  letter-spacing: 0.96px;
  transition: color 0.3s;
}
.center-right .center-nav span i {
  display: block;
  margin-top: 20px;
  width: 100%;
  height: 4px;
  background: transparent;
}
.center-right .center-nav span:nth-child(3) {
  position: absolute;
  top: 44px;
  width: 100%;
  height: 4px;
  background-color: rgba(239, 239, 242, 0.5);
  z-index: -1;
}
.center-right .center-nav a:hover {
  color: #140047;
}
.center-right .center-nav a:hover i {
  background-color: #140047;
}
ul {
  width: 1420px;

  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-between; */
}
.center-right ul li {
  /* width: 265px; */
  width: 310px;
  height: 286px;
  margin-right: 26px;
  margin-bottom: 40px;
  display: inline-block;
  box-shadow: 0rem 0.9984px 10.0032px 0rem rgba(206, 206, 206, 0.5);
}
/* .center-right ul li:nth-child(4) {
  width: 326px;
  height: 286px;
  margin-right: 0px;
  display: inline-block;
  box-shadow: 0rem 0.9984px 10.0032px 0rem rgba(206, 206, 206, 0.5);
} */
.center-right ul li .img {
  position: relative;
  height: 195px;
  background-color: #f1f4fb;
}
.center-right ul li .img img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 80%;
  object-fit: contain;
}
.center-right ul li .text {
  width: 100%;
  height: 91px;
  padding: 16px 42px 16px 16px;
  background-color: rgba(255, 255, 255, 0.88);
  font-size: 15px;
  font-weight: 550;

  color: rgba(0, 0, 0, 0.58);
  line-height: 29px;
  letter-spacing: 0.96px;
  text-align: center;
}
#accc {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.77);
  z-index: 998;
  display: none;
}
#blurr.active {
  pointer-events: none;
  user-select: none;
  background-color: rgba(0, 0, 0, 0.77);
  z-index: 998;
}
body {
  position: relative;
}
.none {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 975px;
  background-color: bisque;
  z-index: 999;
  visibility: hidden;
  opacity: 0;
  transition: 0.5s;
}
.none .button {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: white;
  padding: 33px;
}
.none .a {
  position: absolute;
  right: -45px;
  top: -13px;
  display: block;
  width: 26px;
  height: 26px;
  cursor: pointer;
  background: url(../../assets/img/case/icon_close@2x.png) no-repeat;
  background-size: 100% 100%;
}
.none img {
  width: 910px;
  /* height: 618px; */
  height: 100%;
  object-fit: cover;
}
.none h1 {
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: 400;
  color: #1d1e20;
  line-height: 25px;
  letter-spacing: 0.9984px;
}
.none p {
  font-size: 14px;
  font-weight: 400;
  color: rgba(29, 29, 29, 0.44);
  line-height: 28px;
  letter-spacing: 0.9984px;
  padding-bottom: 40px;
}
#popular.active {
  top: 366.0096px;
  visibility: visible;
  opacity: 1;
  transition: 0.5s;
}

.pagination {
  text-align: center;
  /* padding-bottom: 20px; */
}
.pagination >>> .el-pager .active {
  background-color: #140047 !important;
  color: #fff;
}
.pagination >>> .number,
.pagination >>> .btn-prev,
.pagination >>> .btn-next {
  background-color: #fff !important;
  border-radius: 6px !important;
  border: 1px solid #dddddd;
}
.pagination >>> .el-icon-more {
  background-color: #fff !important;
}
.news-right .pagination {
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/qn/honor.vue